import { observer, useLocalObservable } from "mobx-react";
import TopTabs from "./component/TopTabs";
import PersonCountArea from "./component/PersonCountArea";
import React, { useEffect } from "react";
import HomePageListView from "./HomePageListView";
import HomePageStore from "./store/HomePageStore";
import useSnackbarMessage from "shared/snackbar";
import { useRootStore } from "store/StoreContextProvider";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { AggregationModel } from "domains/models/AggregationModel";

function HomePage() {
  const pageStore = useLocalObservable(() => new HomePageStore());
  const snackbar = useSnackbarMessage();
  const { loginStore, headerStore } = useRootStore();
  const navigate = useNavigate();

  useEffect(() => {
    fetchTargetsByDeptCode();
    headerStore.setPageTitle("PAS");
  }, []);

  const fetchTargetsByDeptCode = async () => {
    try {
      if (loginStore.currentUser) {
        const aggRes = await pageStore.fetchAggregaion(
          loginStore.currentUser.userData.aggregationId!
        );
        //console.log(aggRes);
        pageStore.setCurrentAggregation(
          aggRes.docs as unknown as AggregationModel
        );
        
        const res = await pageStore.fetchTargetsByDeptCode(
          loginStore.currentUser
        );

       
        if (res?.expired) {
          loginStore.onLogout();
          navigate("/login");
          return;
        }
      } else {
        loginStore.onLogout();
        navigate("/login");
        return;
      }
    } catch (err: any) {
      console.log(err);
      if (err.response.data.header.code === 1) {
        snackbar.error("어드민에서 동료와 부하직원 리스트를 설정해주세요");
      } else {
        snackbar.error(err.message);
      }
    }
  };
  return (
    <>
      {/* <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1, backgroundColor: '#f5f5f5'}}> */}
        <TopTabs pageStore={pageStore} />
        <PersonCountArea pageStore={pageStore} />
      {/* </div> */}
      <Grid
        paddingLeft={2.5}
        paddingRight={2.5}
        paddingTop={2}
        style={{
          height: "calc(100vh - 200px)",
        
        }}
      >
        <HomePageListView pageStore={pageStore} />
      </Grid>
    </>
  );
}

export default observer(HomePage);
